<template>
  <div style="padding-top: 50px">
    <div style="font-weight: bold; font-size: 18px; margin-bottom: 4px">
      幸福驾道出行平台价格公示
    </div>
    <div style="display: flex">
      <div
        v-for="(item, index) in priceList"
        :key="index"
        style="
          border: 1px solid;
          padding: 15px;
          margin-right: 16px;
          font-size: 14px;
        "
      >
        <div class="form_alone">
          {{ item.title }}
        </div>
        <div class="form_alone">分段起步费用</div>
        <div>
          <div class="form_item">
            <div class="tab_label">
              普通时段（{{ item.startDistance }}公里，{{
                item.startPackageTime
              }}分钟）
            </div>
            <div class="tab_value">{{ item.startPrice }}元</div>
          </div>
          <div
            v-for="(ite, key, ind) in item.startPriceInterval"
            :key="ind"
            class="form_item"
          >
            <div class="tab_label">
              {{ key }}（{{ item.startDistance }}公里，{{
                index == 2 ? 9 : item.startPackageTime
              }}分钟）
            </div>
            <div class="tab_value">{{ ite }}元</div>
          </div>
        </div>
        <div class="form_alone">分段里程费</div>
        <div>
          <div class="form_item">
            <div class="tab_label">普通时段</div>
            <div class="tab_value">{{ item.normalUnitPrice }}元/公里</div>
          </div>
          <div
            v-for="(ite, key, ind) in item.distanceInterval"
            :key="ind"
            class="form_item"
          >
            <div class="tab_label">{{ key }}</div>
            <div class="tab_value">{{ ite }}元/公里</div>
          </div>
        </div>
        <div class="form_alone">分段时长费</div>
        <div>
          <div class="form_item">
            <div class="tab_label">普通时段</div>
            <div class="tab_value">{{ item.timeUnitPrice }}元/分钟</div>
          </div>
          <div
            v-for="(ite, key, ind) in item.timeInterval"
            :key="ind"
            class="form_item"
          >
            <div class="tab_label">{{ key }}</div>
            <div class="tab_value">{{ ite }}元/分钟</div>
          </div>
        </div>
        <div class="form_alone">远途费</div>
        <div>
          <div
            v-for="(ite, key, ind) in item.distanceSerialInterval"
            :key="ind"
            class="form_item"
          >
            <div class="tab_label">
              <span>超过{{ key }}公里</span>
              <span v-if="Object.keys(item.distanceSerialInterval)[ind + 1]"
                >~{{
                  Object.keys(item.distanceSerialInterval)[ind + 1]
                }}公里</span
              >
              <span>，额外收取</span>
            </div>
            <div class="tab_value">{{ ite }}元/公里</div>
          </div>
        </div>
        <div>
          <div class="form_alone">临时加价</div>
          <div class="form_alone">
            当处于高峰时段，周围司机较少，或司机距离乘客较远时，为鼓励司机更快接单，平台会对订单进行适当加价。加价系数最高为1.5倍，加价金额上限为39.0元
          </div>
        </div>
      </div>
    </div>
    <div style="margin: 4px 0 8px">
      于2023年7月15号公示 适用区域:浙江省杭州市全区域
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      priceList: [
        {
          title: "（工作日）实时单计价规则",
          startPrice: "13.80",
          startDistance: "3.5",
          startPackageTime: "11",
          normalUnitPrice: "1.58", //普通时段里程费
          timeUnitPrice: "0.26", //普通时段时间费
          startPriceInterval: {
            "00:00-06:00": "14.43",
            "07:30-09:30": "14.15",
            "17:00-19:00": "14.15",
            "21:00-22:00": "13.70",
            "22:00-23:00": "13.80",
            "23:00-23:59": "13.99",
          },
          distanceInterval: {
            "00:00-06:00": "2.10",
            "07:30-09:30": "1.98",
            "17:00-19:00": "1.75",
            "21:00-22:00": "1.79",
            "22:00-23:00": "1.78",
            "23:00-23:59": "2.13",
          },
          timeInterval: {
            "00:00-06:00": "0.42",
            "07:30-09:30": "0.40",
            "17:00-19:00": "0.35",
            "21:00-22:00": "0.25",
            "22:00-23:00": "0.33",
            "23:00-23:59": "0.44",
          },
          distanceSerialInterval: {
            15: "0.46",
            25: "0.81",
            40: "1.00",
          },
        },
        {
          title: "（节假日）实时单计价规则",
          startPrice: "13.82",
          startDistance: "3.5",
          startPackageTime: "10",
          normalUnitPrice: "1.63", //普通时段里程费
          timeUnitPrice: "0.27", //普通时段时间费
          startPriceInterval: {
            "00:00-06:00": "14.43",
            "17:00-19:00": "14.06",
            "21:00-23:00": "14.00",
            "23:00-23:59": "14.20",
          },
          distanceInterval: {
            "00:00-06:00": "1.99",
            "17:00-19:00": "1.95",
            "21:00-23:00": "1.62",
            "23:00-23:59": "2.02",
          },
          timeInterval: {
            "00:00-06:00": "0.34",
            "17:00-19:00": "0.35",
            "21:00-23:00": "0.27",
            "23:00-23:59": "0.34",
          },
          distanceSerialInterval: {
            15: "0.46",
            25: "0.78",
            40: "0.96",
          },
        },
        {
          title: "（工作日）预约单计价规则",
          startPrice: "27.00",
          startDistance: "3.0",
          startPackageTime: "10",
          normalUnitPrice: "1.58", //普通时段里程费
          timeUnitPrice: "0.26", //普通时段时间费
          startPriceInterval: {
            "00:00-06:00": "35.00",
          },
          distanceInterval: {
            "00:00-06:00": "2.18",
            "07:30-09:30": "1.98",
            "17:00-19:00": "1.75",
            "21:00-22:00": "1.79",
            "22:00-23:00": "1.80",
            "23:00-23:59": "2.18",
          },
          timeInterval: {
            "00:00-06:00": "0.42",
            "07:30-09:30": "0.40",
            "17:00-19:00": "0.35",
            "21:00-22:00": "0.25",
            "22:00-23:00": "0.33",
            "23:00-23:59": "0.43",
          },
          distanceSerialInterval: {
            15: "0.46",
            25: "0.81",
            40: "1.00",
          },
        },
        {
          title: "（节假日）预约单计价规则",
          startPrice: "25.00",
          startDistance: "3.0",
          startPackageTime: "10",
          normalUnitPrice: "1.63", //普通时段里程费
          timeUnitPrice: "0.27", //普通时段时间费
          startPriceInterval: {
            "00:00-06:00": "35.00",
          },
          distanceInterval: {
            "00:00-06:00": "1.99",
            "17:00-19:00": "1.96",
            "21:00-23:00": "1.63",
            "23:00-23:59": "2.03",
          },
          timeInterval: {
            "00:00-06:00": "0.34",
            "17:00-19:00": "0.34",
            "21:00-23:00": "0.27",
            "23:00-23:59": "0.34",
          },
          distanceSerialInterval: {
            15: "0.46",
            25: "0.81",
            40: "1.00",
          },
        },
      ],
    };
  },
};
</script>
<style scoped>
.form_alone {
  padding: 5px 0;
}
.form_item {
  display: flex;
  justify-content: space-between;
  padding: 3px 0;
}
.tab_label {
  width: 72%;
  text-align: left;
}
.tab_value {
  flex: 1;
  text-align: right;
}
</style>
